import { render, staticRenderFns } from "./OverlayedCanvas.vue?vue&type=template&id=146a15a2&scoped=true&"
import script from "./OverlayedCanvas.vue?vue&type=script&lang=js&"
export * from "./OverlayedCanvas.vue?vue&type=script&lang=js&"
import style0 from "./OverlayedCanvas.vue?vue&type=style&index=0&id=146a15a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146a15a2",
  null
  
)

export default component.exports